module.exports = __webpack_public_path__ + "static/img/wx_qcode.d8a10d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx_qcode.png
// module id = t7rx
// module chunks = 23